import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
    const location = useLocation();

    const menuItems = [
        { path: "/dashboard", label: "Dashboard", icon: "📊" },
        // { path: "/create-user", label: "Create User", icon: "👤" },
        { path: "/users", label: "User List", icon: "👥" },
        { path: "/members", label: "Members", icon: "🤝" },
        { path: "/donations", label: "Donations", icon: "💰" },
        { path: "/events", label: "Events", icon: "📅" },
        { path: "/gallery", label: "Gallery", icon: "🖼️" },
        { path: "/notices", label: "Notices", icon: "📢" },
        { path: "/enquiry", label: "Enquiry", icon: "📧" },
        { path: "/settings", label: "Settings", icon: "⚙️" },
    ];

    return (
        <div className="sidebar">
            <h2><span></span> <span>Admin Panel</span></h2>
            {menuItems.map((item) => (
                <Link
                    key={item.path}
                    to={item.path}
                    className={location.pathname === item.path ? "active" : ""}
                >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                </Link>
            ))}
        </div>
    );
}